import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';

import { StandortEditComponent } from './standort_edit.component';
import { StandortEditRoutingModule } from './standort_edit-routing.module';
import { LabelPreviewDialogComponent } from './label-preview-dialog/label-preview-dialog.component';

// Import modules for embedded components
import { ObjektStrukturTreetableModule } from '../components/objekt-struktur-treetable/objekt-struktur-treetable.module';
import { PlanModule } from '../plan/plan.module';
import { DokumenteModule } from '../dokumente/dokumente.module';
import { ProjektaufgabeModule } from '../projektaufgabe/projektaufgabe.module';
import { KontrollterminPreviewModule } from '../components/kontrolltermin-preview/kontrolltermin-preview.module';

@NgModule({
  declarations: [
    StandortEditComponent,
    LabelPreviewDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    StandortEditRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatMenuModule,
    MatCheckboxModule,
    MatTooltipModule,
    
    // Embedded component modules
    ObjektStrukturTreetableModule,
    PlanModule,
    DokumenteModule,
    ProjektaufgabeModule,
    KontrollterminPreviewModule,
  ],
  exports: [StandortEditComponent],
  providers: [],
})
export class StandortEditModule {}

